export class RuleWrapperPLCDTO {
    Rules: RulePLCDTO[];
}

export class RulePLCDTO {
    houseId: string;
    deviceId: string;
    moduleId: any;
    correlationId: string;
    type: string;
    rules: {
        desired: {
            enabled: boolean;
            rules: RuleDefinitionPLCDTO[];
        },
        reported: {
            enabled: boolean;
            rules: RuleDefinitionPLCDTO[];
        }
    };
}

export class RuleDefinitionPLCDTO {
    state: boolean;
    moduleId: string;
    moduleIds: {
        priorityDisconnect: string[];
        priorityReconnect: string[];
        };
    powerLimit: number;
    power: number;
    type: string;
    activity: {
        start: {
            hour: number;
            minute: number;
        },
        end: {
            hour: number;
            minute: number;
        },
        startRepeat: {
            daysOfWeek: number[];
        },
        startAction: {
            command: string;
            setpoint: number;
            mode: string;
        }
    };
    ruleType: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/DTO/RulePLCDTO.ts